/** German org-admin UI copy (sidebar, tabs, dialogs, billing tab). */

import {
  WC2026_ORG_BILLING_DISCLOSURE,
  WC2026_ORG_BILLING_DISCLOSURE_SHORT,
} from '../../../shared/constants/wc2026OrgBillingDisclosure.constants'

export const accountAdminCopyDe = {
  backToSite: '← Zurück zur Website',
  ORG_DRAWER_PARENT_FALLBACK: 'Organisationen',
  FRIENDS_ENTRY_LABEL: 'Organisation verwalten',
  FRIENDS_ENTRY_HINT: 'Branding & Mitglieder',
  START_HERE: 'Hier starten',
  START_HERE_INTRO:
    'Nutze die Organisationsnavigation, um zwischen Hier starten, Branding, Mitglieder und Einstellungen zu wechseln. Dann:',
  OPEN_MENU: 'Menü öffnen',
  BRANDING: 'Branding',
  MEMBERS: 'Mitglieder',
  SETTINGS: 'Einstellungen',
  PLAN_BILLING: 'Plan',
  PLAN_BILLING_INTRO:
    'Upgrade deine Organisation im Web, verwalte Zahlungsmethoden und sieh Rechnungen im Stripe-Kundenportal ein.',
  PLAN_BILLING_CURRENT: 'Aktueller Plan',
  PLAN_BILLING_RENEWS: 'Verlängert oder endet am',
  PLAN_BILLING_STATUS: 'Abonnementstatus',
  PLAN_BILLING_UPGRADE_BUSINESS: 'Auf Business upgraden',
  PLAN_BILLING_UPGRADE_ENTERPRISE: 'Auf Enterprise upgraden',
  PLAN_BILLING_PORTAL: 'Abrechnung & Rechnungen verwalten',
  PLAN_BILLING_WEB_ONLY: 'Pläne sind im Web verfügbar.',
  INVOICE_DETAILS: 'Abrechnung & Rechnung',
  INVOICE_DETAILS_WEB_ONLY: 'Abrechnung & Rechnung sind im Web verfügbar.',
  MANAGE_PLAN_BILLING: 'Plan verwalten',
  COMPARE_PLANS: 'Pläne vergleichen',
  NO_ORG_TITLE: 'Noch keine Organisation',
  NO_ORG_SUBTITLE: 'Erstelle eine, um Branding und Mitglieder zu verwalten, oder tritt mit einem Code bei.',
  CREATE_PLACEHOLDER: 'Organisationsname',
  CREATE_CTA: 'Organisation erstellen',
  JOIN_PLACEHOLDER: 'Beitrittscode',
  JOIN_CTA: 'Beitreten',
  MEMBER_ONLY_TITLE: 'Mitgliederzugriff',
  MEMBER_ONLY_MESSAGE:
    'Nur Organisations-Admins können Branding und Einstellungen ändern. Wende dich an deinen Admin, wenn du Änderungen brauchst.',
  MEMBER_INVITE_RETURN_TITLE: 'Du bist bereits in dieser Organisation',
  MEMBER_INVITE_RETURN_MESSAGE:
    'Dieser Link ist für Teammitglieder, die noch beitreten müssen. Du bist als Mitglied angemeldet — es gibt nichts zu akzeptieren. Nur Admins können Branding und Einstellungen ändern.',
  B2B_LOGO_MAX_COUNT: 1,
  BRAND_IMAGERY_SECTION_TITLE: 'Markenbilder',
  UPLOAD_LOGOS: 'Logo hochladen',
  LOGO_TILE_LABEL: 'Logo',
  LOGO_TILE_EMPTY: 'Logo hinzufügen',
  BANNER_TILE_LABEL: 'Squad-Banner',
  BANNER_TILE_EMPTY: 'Banner hinzufügen',
  UPLOAD_BANNER: 'Banner hochladen',
  REPLACE_BANNER: 'Banner ersetzen',
  REMOVE_BANNER: 'Banner entfernen',
  REMOVE_BANNER_CONFIRM_TITLE: 'Dieses Banner entfernen?',
  REMOVE_BANNER_CONFIRM_MESSAGE: 'Das Squad fällt auf den Markenfarbverlauf zurück.',
  LOGOS_UPLOAD_LIMITS_PLACEHOLDER: '',
  LOGOS_UPLOAD_HINT:
    'PNG, JPG, WebP oder SVG. Max. 2 MB. Quadratisch (1:1), 512–1024 px pro Seite. Transparentes PNG bevorzugt.',
  BANNER_UPLOAD_HINT:
    'PNG, JPG oder WebP. Max. 2 MB. Breites 4:1-Format — 1600×400 px empfohlen, min. 1200×300 px.',
  USE_BANNER_BACKGROUND_LABEL: 'Bannerbild als Squad-Hintergrund verwenden',
  USE_BANNER_BACKGROUND_HINT:
    'Wenn aktiviert, zeigt der Squad-Hero dein Bannerbild statt des Primär-/Sekundärfarbverlaufs.',
  USE_BANNER_BACKGROUND_DISABLED_HINT: 'Lade zuerst ein Bannerbild hoch, um diese Option zu aktivieren.',
  USE_BANNER_BACKGROUND_SAVED: 'Gespeichert',
  REMOVE_LOGO: 'Entfernen',
  DOWNLOAD_LOGO: 'Herunterladen',
  DOWNLOAD_LOGO_ERROR: 'Bild konnte nicht heruntergeladen werden',
  REMOVE_LOGO_CONFIRM_TITLE: 'Dieses Logo entfernen?',
  REMOVE_LOGO_CONFIRM_MESSAGE: 'Es wird für deine Organisation nicht mehr angezeigt.',
  LOGO_FILE_TOO_LARGE: 'Dieses Bild überschreitet das 2-MB-Upload-Limit. Versuche eine kleinere Datei.',
  SAVE_COLORS: 'Farben speichern',
  COLORS_SAVED: 'Farben gespeichert',
  PRIMARY: 'Primär',
  SECONDARY: 'Sekundär',
  COLOR_PRESETS: 'Voreinstellungen',
  COLOR_PALETTE_LABEL: 'Palette',
  COLOR_PALETTE_SATURATION_A11Y: 'Sättigung und Helligkeit. Ziehen, um die Farbe zu wählen.',
  COLOR_PALETTE_HUE_A11Y: 'Farbton. Ziehen, um die Farbe zu ändern.',
  CUSTOM_HEX_LABEL: 'Benutzerdefiniert (Hex)',
  HEX_PLACEHOLDER: '#RRGGBB',
  JOIN_CODE: 'Beitrittscode',
  SQUAD_JOIN_CODE: 'Squad-Beitrittscode',
  ADD_MEMBERS_TITLE: 'Teammitglieder hinzufügen',
  ADD_MEMBERS_BODY:
    'Teile den Einladungslink unten. Teammitglieder melden sich bei Zporti an und öffnen den Link, um dieser Organisation beizutreten.',
  ADD_MEMBERS_BODY_WC_SINGLE_PRIMARY:
    'Teile den Einladungslink unten, damit Teammitglieder sich anmelden und dieser Organisation beitreten — sie werden automatisch deinem verknüpften Football-2026-Squad hinzugefügt. Für Freunde außerhalb der Organisation teile eine Squad-Einladung unter Football 2026 → Squads (nicht von dieser Seite).',
  MEMBERS_DIRECTORY: 'Mitgliederverzeichnis',
  MEMBERS_ADMIN_HINT:
    'Admins können Branding, Mitglieder und Einstellungen verwalten. Nutze Zum Admin machen / Degradieren / Entfernen in der Spalte Aktionen.',
  MEMBERS_TABLE_NAME: 'Name',
  MEMBERS_TABLE_EMAIL: 'E-Mail',
  MEMBERS_TABLE_ROLE: 'Rolle',
  MEMBERS_TABLE_JOINED: 'Beigetreten',
  MEMBERS_TABLE_ACTIONS: 'Aktionen',
  MEMBERS_TABLE_NO_ACTIONS_VISIBLE: 'Keine Aktionen',
  MEMBER_ACTION_LOADING_A11Y: 'Mitglied wird aktualisiert',
  MEMBERS_BULK_REMOVE_LOADING_A11Y: 'Ausgewählte Mitglieder werden entfernt',
  MEMBERS_TABLE_NO_ACTIONS_A11Y:
    'Keine Aktionen. Du kannst deine eigene Zeile nicht bearbeiten, oder für dieses Mitglied gibt es nichts zu ändern.',
  ROLE_LABEL_ADMIN: 'Admin',
  ROLE_LABEL_MEMBER: 'Mitglied',
  MEMBERS_EMPTY: 'Noch keine Mitglieder.',
  MEMBER_ROW_YOU_INLINE: ' (Du)',
  INVITE_LINK: 'Einladungslink',
  INVITE_LINK_HINT: 'Teile diesen Link, damit Teammitglieder sich anmelden und deiner Organisation beitreten.',
  INVITE_LINK_HINT_WC:
    'Dieser Link öffnet den Organisationsbeitritt. Nach der Anmeldung treten sie der Org und deinem verknüpften Football-2026-Squad gemeinsam bei.',
  INVITE_LINK_QR_HINT: 'Mit der Handykamera scannen, um diesen Link zu öffnen.',
  INVITE_LINK_QR_A11Y:
    'QR-Code für den Einladungslink. Mit der Handykamera scannen, um die Beitrittsseite zu öffnen.',
  COPY_INVITE_LINK: 'Link kopieren',
  VIEW_LINKED_SQUAD: 'Squad-Seite ansehen',
  VIEW_LINKED_SQUAD_A11Y: 'Verknüpftes Football-2026-Squad öffnen, um Ergebnisse vorzuschauen',
  SEATS: 'Plätze',
  SEATS_UNLIMITED: 'Unbegrenzt',
  MAKE_ADMIN: 'Zum Admin machen',
  MAKE_ADMIN_TITLE: 'Dieses Mitglied zum Admin machen?',
  MAKE_ADMIN_MESSAGE:
    'Es kann Branding, Mitglieder und Organisationseinstellungen verwalten.',
  DEMOTE_ADMIN: 'Degradieren',
  DEMOTE_ADMIN_TITLE: 'Diesen Admin degradieren?',
  DEMOTE_ADMIN_MESSAGE: 'Es behält den Zugriff als Mitglied, verliert aber Admin-Rechte.',
  REMOVE_MEMBER: 'Entfernen',
  MEMBERS_BULK_SELECT: 'Mehrere auswählen',
  MEMBERS_BULK_CANCEL_SELECT: 'Auswahl abbrechen',
  MEMBERS_BULK_REMOVE: 'Ausgewählte entfernen',
  MEMBERS_BULK_REMOVE_TITLE: 'Ausgewählte Mitglieder entfernen?',
  MEMBERS_BULK_REMOVE_MESSAGE:
    'Sie verlieren den Zugriff auf diese Organisation (und das verknüpfte Football-2026-Squad, falls vorhanden). Dies kann nicht rückgängig gemacht werden.',
  MEMBERS_BULK_REMOVE_CONFIRM: 'Entfernen',
  MEMBERS_BULK_ROW_CHECKBOX_A11Y: 'Mitglied für Massenentfernung auswählen',
  MEMBERS_BULK_CANCEL_DIALOG: 'Abbrechen',
  MEMBERS_BULK_REMOVE_FAILED: 'Massenentfernung fehlgeschlagen',
  MEMBERS_INVITE_LINK_COPIED: 'Link kopiert',
  membersBulkRemoveSummary: (removed: number, skipped: number) =>
    `${removed} entfernt; ${skipped} übersprungen`,
  membersBulkRemoveDone: (removed: number) => `${removed} entfernt`,
  MEMBERS_BULK_SELECT_ALL_A11Y: 'Alle Mitglieder außer dir auswählen oder abwählen',
  ACCOUNT_NAME: 'Organisationsname',
  SAVE_NAME: 'Name speichern',
  WC_LINKED_SQUAD_SECTION_TITLE: 'Verknüpftes Football-2026-Squad',
  WC_LINKED_SQUAD_SECTION_BODY_LINKED:
    'Das ist dasselbe Squad wie unter Football 2026 → Squads. Ändere den Squad-Namen hier oder auf diesem Bildschirm. Teile den Organisations-Einladungslink im Tab Mitglieder: Neue Mitglieder treten zuerst der Org bei, werden automatisch diesem Squad hinzugefügt und öffnen dann das Squad.',
  WC_LINKED_SQUAD_SECTION_BODY_NOT_LINKED:
    'Füge einen Football-2026-Squad-Einladungscode ein, um dieses Squad mit dieser Organisation zu verknüpfen. Nach der Verknüpfung wird jeder, der über den Organisations-Einladungslink im Tab Mitglieder beitritt, automatisch dem Squad hinzugefügt.',
  WC_LINKED_SQUAD_NAME_LABEL: 'Squad-Name',
  WC_LINKED_SQUAD_INVITE_CODE_LABEL: 'Squad-Einladungscode',
  WC_LINKED_SQUAD_CODE_PLACEHOLDER: 'Squad-Einladungscode einfügen',
  WC_LINKED_SQUAD_SAVE_NAME: 'Squad-Namen speichern',
  WC_LINKED_SQUAD_LINK_SQUAD: 'Squad verknüpfen',
  ORG_ONLY_JOIN_CODE_TITLE: 'Organisationseinladung',
  ORG_ONLY_JOIN_CODE_BODY:
    'Teile den Einladungslink, damit Personen zuerst der Organisation beitreten; sie werden automatisch dem Squad hinzugefügt und können es unter Football 2026 → Squads öffnen.',
  COPY_ORG_INVITE_LINK: 'Einladungslink kopieren',
  PLAN_TIER: 'Plan',
  MEMBERSHIP_POLICY_TITLE: 'Mitgliederlimit',
  MEMBERSHIP_POLICY_UNLIMITED_LABEL: 'Unbegrenzte Mitglieder',
  MEMBERSHIP_POLICY_UNLIMITED_APPROVED_HELP:
    'Unbegrenzte Beitritte per Einladungslink sind für diese Organisation nach Zporti-Freigabe aktiviert.',
  MEMBERSHIP_POLICY_FROM_PLAN_HELP:
    'Dein Plan umfasst unbegrenzte Mitglieder per Einladungslink. Keine Aktion erforderlich.',
  MEMBERSHIP_POLICY_PENDING_HELP:
    'Deine Anfrage ist ausstehend. Zporti aktiviert unbegrenzte Mitglieder nach Prüfung.',
  MEMBERSHIP_POLICY_LIMITED_HELP:
    'Wenn deaktiviert, sind Beitritte per Einladungslink durch dein Platzlimit begrenzt (Standard 100 bei Starter).',
  MEMBERSHIP_POLICY_ENABLE_DIALOG_TITLE: 'Unbegrenzte Mitglieder anfragen?',
  MEMBERSHIP_POLICY_ENABLE_DIALOG_MESSAGE:
    'Dies sendet eine Anfrage an Zporti. Wir prüfen und aktivieren unbegrenzte Beitritte per Einladungslink für deine Organisation. Bis dahin kannst du dein aktuelles Platzlimit weiter nutzen. Anfrage jetzt senden?',
  MEMBERSHIP_POLICY_ENABLE_DIALOG_CONFIRM: 'Anfrage senden',
  MEMBERSHIP_POLICY_REQUEST_SENT: 'Anfrage gesendet',
  MEMBERSHIP_POLICY_CANCEL_REQUEST_LINK: 'Anfrage abbrechen',
  MEMBERSHIP_POLICY_CANCEL_DIALOG_TITLE: 'Anfrage für unbegrenzte Mitglieder abbrechen?',
  MEMBERSHIP_POLICY_CANCEL_DIALOG_MESSAGE:
    'Dies zieht deine ausstehende Anfrage zurück. Zporti wird über die Stornierung informiert.',
  MEMBERSHIP_POLICY_CANCEL_CONFIRM: 'Anfrage abbrechen',
  MEMBERSHIP_POLICY_CANCEL_DONE: 'Anfrage abgebrochen',
  BILLING_GATE_LOCKED_TITLE: 'Abrechnung abschließen zum Freischalten',
  BILLING_GATE_LOCKED_BODY:
    'Richte den Organisationsplan ein, um Branding, Mitglieder und Einstellungen zu nutzen.',
  BILLING_GATE_GO_TO_BILLING: 'Zum Plan',
  DEACTIVATE: 'Organisation deaktivieren',
  DEACTIVATE_CONFIRM_TITLE: 'Organisation deaktivieren?',
  DEACTIVATE_CONFIRM_MESSAGE:
    'Mitglieder verlieren Organisationsvorteile, bis der Support die Organisation reaktiviert.',
  INACTIVE_TITLE: 'Inaktiv',
  INACTIVE_BODY:
    'Diese Organisation ist deaktiviert. Du kannst sie reaktivieren, wenn das ein Fehler war.',
  REACTIVATE: 'Reaktivieren',
  REMOVE_MEMBER_TITLE: 'Mitglied entfernen?',
  REMOVE_MEMBER_MESSAGE: 'Es verliert den Zugriff auf diese Organisation.',
  LEAVE_ORG_TITLE: 'Diese Organisation verlassen?',
  LEAVE_ORG_MESSAGE:
    'Du verlierst den Zugriff auf Branding- und Mitglieder-Tools für diese Org. Danach kannst du eine neue Organisation erstellen oder einer beitreten.',
  LEAVE_ORG_CONFIRM: 'Organisation verlassen',
  LEAVE_ORG_MEMBER_HINT:
    'Um die Vorteile dieser Organisation nicht mehr zu nutzen, kannst du sie verlassen. Dein Admin kann dich mit einer Einladung wieder hinzufügen.',
  LEAVE_ORG_DONE_TITLE: 'Du hast die Organisation verlassen',
  LEAVE_ORG_DONE_MESSAGE: 'Du kannst von dieser Seite aus eine neue Organisation erstellen oder mit einem Code einer beitreten.',
  LEAVE_ORG_SOLE_ADMIN_HINT:
    'Du bist der einzige Admin. Befördere ein anderes Mitglied zum Admin unter Mitglieder, dann kannst du gehen.',
  DEACTIVATE_PERMANENT_DELETE_FOOTNOTE:
    'Nach der Deaktivierung erscheint in diesem Tab unter Organisation verlassen ein Bereich für endgültiges Löschen mit Bestätigungsfeld.',
  DELETE_ORG_SECTION_TITLE: 'Endgültig löschen',
  DELETE_ORG_SECTION_BODY:
    'Dies entfernt die Organisation und alle Mitgliedschaften aus unseren Systemen. Gib die exakte Phrase unten ein: das Wort delete in Kleinbuchstaben, ein Leerzeichen, dann dein Organisationsname genau wie gespeichert.',
  DELETE_ORG_NAME_LABEL: 'Diese Phrase exakt eingeben',
  DELETE_ORG_BUTTON: 'Organisation endgültig löschen',
  DELETE_ORG_DIALOG_TITLE: 'Diese Organisation endgültig löschen?',
  DELETE_ORG_DIALOG_MESSAGE:
    'Dies kann nicht rückgängig gemacht werden. Alle Mitglieder verlieren den Zugriff und Branding-Daten werden entfernt.',
  setupGuide: {
    TITLE: 'Empfohlene Einrichtungsreihenfolge',
    LINE_BRANDING_BEFORE: 'Lege deine ',
    LINE_BRANDING_LINK: 'Logos und Markenfarben',
    LINE_BRANDING_AFTER: ' fest, damit Mitglieder deine Organisation erkennen.',
    LINE_MEMBERS_BEFORE: 'Lade dein Team ein unter ',
    LINE_MEMBERS_AFTER: ' mit deinem Einladungslink oder Beitrittscode.',
    LINE_SETTINGS_BEFORE: 'Prüfe Organisationsname und Plan unter ',
    LINE_SETTINGS_AFTER: '.',
  },
  navShort: {
    START_HERE: 'Start',
    BRANDING: 'Marke',
    MEMBERS: 'Mitglieder',
    SETTINGS: 'Einstellungen',
    PLAN_BILLING: 'Plan',
    INVOICE_DETAILS: 'Abrechnung',
  },
  navLockedA11ySuffix: ' — Abrechnung abschließen zum Freischalten',
  brandingPreview: {
    SECTION_LABEL: 'Vorschau',
    SQUAD_PLACEHOLDER_NAME: 'Dein Team',
    COMPANY_NAME_PLACEHOLDER: 'Deine Organisation',
    COLOR_PRIMARY_LABEL: 'Primärfarbe',
    COLOR_SECONDARY_LABEL: 'Sekundärfarbe',
    HERO_BACK_LABEL: 'Teams',
    HERO_COMPANY_GROUP_LABEL: 'Unternehmensgruppe',
    HERO_EMPLOYEES_LABEL: 'Mitglieder',
  },
  sso: {
    TITLE: 'Firmen-Anmeldung (SSO)',
    BODY:
      'Beschränken Sie diese Organisation auf Nutzer mit einer bestimmten Firmen-E-Mail-Domain. Wenn aktiviert, werden neue Mitglieder, die sich mit Google über diese Domain anmelden, automatisch hinzugefügt — ohne Einladungslink. Bestehende Mitglieder sind nicht betroffen.',
    CHECKBOX_LABEL: 'Auf Firmen-E-Mail-Domain beschränken',
    DOMAIN_PLACEHOLDER: 'acme.com',
    SAVE_BUTTON: 'SSO-Einstellungen speichern',
    INVALID_DOMAIN: 'Geben Sie eine gültige Domain ein (z. B. acme.com)',
    domainRestricted: (domain: string) => `Domain beschränkt auf @${domain}`,
    DOMAIN_REMOVED: 'Domain-Beschränkung entfernt',
    SAVE_FAILED: 'SSO-Einstellungen konnten nicht gespeichert werden',
  },
  billing: {
    ORGANIZATION_PLAN_LABEL: 'Organisationsplan',
    PLAN_PICKER_HEADING: 'Wähle deinen Plan',
    PLAN_PICKER_SUBHEADING:
      'Einmaliger WC-2026-Organisationszugang — Branding, Mitgliedssitze und verknüpftes Team für die Turnierphase.',
    PLAN_BUSINESS_NAME: 'Business',
    PLAN_BUSINESS_PRICE: 'Ab $450',
    PLAN_BUSINESS_TAGLINE:
      'Einmalige Self-Service-Org-Gebühr. Wähle deinen Sitz-Tarif und zahle einmal für WC-2026-Turnierzugang.',
    ORG_BILLING_DISCLOSURE: WC2026_ORG_BILLING_DISCLOSURE,
    ORG_BILLING_DISCLOSURE_SHORT: WC2026_ORG_BILLING_DISCLOSURE_SHORT,
    PLAN_BUSINESS_CTA: 'Loslegen',
    PLAN_ENTERPRISE_NAME: 'Enterprise',
    PLAN_ENTERPRISE_PRICE: 'Individuell',
    PLAN_ENTERPRISE_TAGLINE:
      'Individuelle Preise für große Organisationen. Kontaktiere uns — wir erstellen einen passenden Plan.',
    PLAN_ENTERPRISE_CTA: 'Kontakt',
    CUSTOM_FORM_NAME_LABEL: 'Dein Name',
    CUSTOM_FORM_NAME_PLACEHOLDER: 'Jane Smith',
    CUSTOM_FORM_EMAIL_LABEL: 'Geschäftliche E-Mail',
    CUSTOM_FORM_EMAIL_PLACEHOLDER: 'jane@company.com',
    CUSTOM_FORM_MESSAGE_LABEL: 'Nachricht (optional)',
    CUSTOM_FORM_MESSAGE_PLACEHOLDER: 'Erzähl uns von deiner Organisation und deinen Anforderungen.',
    CUSTOM_FORM_SUBMIT: 'Anfrage senden',
    CUSTOM_FORM_SENT: 'Wir melden uns bald!',
    PERSONAL_PLAN_LABEL: 'Persönlicher Plan',
    ENTERPRISE_QUOTE_LABEL: 'Vereinbarter Enterprise-Preis',
    MANAGE_PORTAL: 'Organisationsabrechnung verwalten',
    MANAGE_PERSONAL_PORTAL: 'Persönliches Abo verwalten',
    COMPARE_PLANS: 'Pläne vergleichen',
    SUBSCRIPTION_STATUS: 'Abonnementstatus',
    PERIOD_END: 'Verlängert oder endet am',
    PERSONAL_BILLING_SECTION: 'Persönliches Abo',
    ORG_BILLING_SECTION: 'Organisationsabo',
    STRIPE_NOT_CONFIGURED:
      'Abrechnung wird eingerichtet. Plandetails sind bald verfügbar.',
    B2B_BILLING_RETURN_SYNCING: 'Stripe-Zahlung wird angewendet…',
    B2B_BILLING_RETURN_SYNCING_A11Y: 'Stripe-Zahlung wird angewendet',
    ORG_SEAT_TIER_LABEL: 'Platz-Stufe',
    ORG_CURRENT_SEAT_TIER_LABEL: 'Aktuelle Platz-Stufe',
    UPGRADE_SEAT_TIER: 'Upgraden',
    SEAT_TIER_UPGRADE_DIALOG_TITLE: 'Platz-Stufe upgraden?',
    SEAT_TIER_UPGRADE_DIALOG_CONFIRM: 'Weiter zur Kasse',
    SEAT_TIER_UPGRADE_DIALOG_CANCEL: 'Abbrechen',
    SEAT_TIER_UPGRADE_DIALOG_CURRENT_PREFIX: 'Aktuelle Platz-Stufe:',
    SEAT_TIER_UPGRADE_DIALOG_TARGET_PREFIX: 'Upgrade auf:',
    SEAT_TIER_UPGRADE_DIALOG_REFUND_BODY:
      'Du hast bereits für deine aktuelle (niedrigere) Platz-Stufe bezahlt. Stripe wird den ungenutzten Anteil dieser Zahlung auf dieses Upgrade anrechnen oder erstatten — die Kasse zeigt den Nettobetrag (Anteiligkeit).',
    SEAT_TIER_UPGRADE_DIALOG_SCOPE_REMINDER: WC2026_ORG_BILLING_DISCLOSURE_SHORT,
    SEAT_TIER_UPGRADE_DIALOG_CONTINUE_PROMPT: 'Fortfahren?',
    NEED_CUSTOM_PLAN: 'Individuellen Plan benötigt?',
    NEED_CUSTOM_PLAN_A11Y: 'Individueller Plan',
    PLAN_TIER_STARTER: 'Starter (kostenlos)',
    PLAN_TIER_PRO: 'Pro',
    PLAN_TIER_BUSINESS: 'Business',
    PLAN_TIER_ENTERPRISE: 'Enterprise',
    SUBSCRIPTION_STATUS_ACTIVE: 'Aktiv',
    SUBSCRIPTION_STATUS_TRIALING: 'Testphase',
    SUBSCRIPTION_STATUS_PAST_DUE: 'Überfällig',
    SUBSCRIPTION_STATUS_CANCELED: 'Gekündigt',
    SUBSCRIPTION_STATUS_UNPAID: 'Unbezahlt',
    SUBSCRIPTION_STATUS_INCOMPLETE: 'Unvollständig',
    SUBSCRIPTION_STATUS_INCOMPLETE_EXPIRED: 'Abgelaufen',
    SUBSCRIPTION_STATUS_PAUSED: 'Pausiert',
  },
} as const
